import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IconComponent } from '../icon/icon.component';
import { UiIconControlDirective } from '../../../directives/ui/ui-icon-control.directive';

@Component({
  selector: 'chip',
  imports: [IconComponent],
  templateUrl: './chip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipComponent extends UiIconControlDirective {}
